import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import BorrowerAttestsNoDebtRuleset from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/ruleset/BorrowerAttestsNoDebtRuleset';
import { RulesetResult } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/rules';
import * as Yup from 'yup';

const {
  formField: { borrowerAttestsNoDebtPick },
} = loanFormModel;

export class BorrowerAttestsNoDebtValidation implements ValidationSchema {
  public name: string = borrowerAttestsNoDebtPick.name;
  public label: string = borrowerAttestsNoDebtPick.getLabel(false, '', '');
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = BorrowerAttestsNoDebtRuleset;

  public when(schema: Yup.StringSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new BorrowerAttestsNoDebtValidation());
